
import React, { useState, useContext, useEffect } from 'react';
import '../styles/casedetails.css';
import { Outlet, Link, useNavigate, useParams } from 'react-router-dom';
import { ShareContext } from '../context/ShareContext'
import * as Constants from '../constants';


import Payment from '../components/core/payment';


function PagePayment() {
  const {  activePage, token, profile,frequentData} = useContext(ShareContext);
     const { feeid } = useParams();
        const [loading, setLoading] =useState(false);
        
  //load the page details
        useEffect(() => {
            
              /* if(payments==null){
               onLoad();
              } */
  
          }, []);
    
  return (
    <div>
        <Payment feeid={feeid} token={token} />

    </div>
  );
}

export default PagePayment;